import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import Img from '../Img';
import { MdxFrontmatterWelcomeBackground } from '../../types/graphql-types';
import { getImage } from "gatsby-plugin-image";

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.colors.background};
`;

const StyledImgOld = styled(Img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  opacity: ${props => (props.theme.mode === 'dark' ? 0.4 : 0.2)};
`;
const StyledImg = styled(Img)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  user-select: none;
  opacity: ${props => (props.theme.mode === 'dark' ? 0.6 : 1)};
`;

type Props = {} & MdxFrontmatterWelcomeBackground;

const calc = (o: number) => `translateY(${o * 0.1}px)`;

const ParallaxBackground: React.FC<Props> = (props) => {
  const ref = useRef<HTMLDivElement>();
  const [offset, setOffset] = useState(0);
  const imgProps = getImage(props.src.childImageSharp.gatsbyImageData);

  const handleScroll = () => {
    const posY = ref.current.getBoundingClientRect().top;
    const newOffset = window.pageYOffset - posY;
    setOffset(newOffset * 2);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <Wrapper ref={ref}>
      <StyledImg
        image={imgProps}
        alt ={props.alt}
        style={{
          transform: calc(offset),
        }}
      />
    </Wrapper>
  );
};

export default ParallaxBackground;
